import React, { Component } from 'react';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';
import Login from "../Login/Login";
import Signup from '../Signup/Signup';

export default class NavLoggedOut extends Component {
    login() {
        this.props.auth.login();
    }

    render() {
        return (
            <div>
                <Nav>
                    <Link to="/aide" className="navigation__menuItem"><div>Aide</div></Link>
                    <Link to="/" onClick={this.login.bind(this)} className="navigation__menuItem"><Signup /></Link>
                    <Link to="/" onClick={this.login.bind(this)} className="navigation__menuItem"><Login /></Link>
                </Nav>
            </div>
        )
    }
}